import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function BestMobilePicksLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          d="M10.5962 3.74359C10.7767 3.44126 11.1028 3.2561 11.4549 3.2561H23.1799C23.9561 3.2561 24.4364 4.10205 24.0385 4.76861L14.8997 20.0803C14.7192 20.3826 14.3931 20.5678 14.041 20.5678H2.31599C1.53973 20.5678 1.05947 19.7218 1.45731 19.0553L10.5962 3.74359Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M12.0716 22.1721C11.7195 22.1721 11.3934 22.3573 11.2129 22.6596L8.40457 27.3649C8.00673 28.0314 8.48699 28.8774 9.26325 28.8774H21.6549C22.007 28.8774 22.3331 28.6922 22.5136 28.3899L31.6525 13.0782C32.0503 12.4116 31.57 11.5657 30.7938 11.5657H22.2581C21.906 11.5657 21.5798 11.7508 21.3994 12.0532L15.6508 21.6846C15.4703 21.9869 15.1442 22.1721 14.7921 22.1721H12.0716Z"
          fill="white"
        />
      </svg>
      <span>Best Mobile Picks</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
